import { IAdvertiserPublisherRelation } from 'src/common/models/advertiserPublisherRelation';

export default function getSocialAccounts(relation: IAdvertiserPublisherRelation) {
  return (
    (relation.publisher && relation.publisher.social_accounts) ||
    (relation.metadata && relation.metadata.accounts)
  );
}
